import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'
import theme from 'theme_'


import MontserratRegular from 'fonts/Montserrat-Regular.woff'
import MontserratBold from 'fonts/Montserrat-Bold.woff'

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  @font-face {
    font-family: 'Montserrat';
    src: url('${MontserratRegular}') format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Montserrat';
    src: url('${MontserratBold}') format('woff');
    font-weight: 700;
    font-style: normal;
  }

  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    color: ${theme.colors.otterWarmBlack};
    font-size: 16px;
    font-family: ${theme.fonts.base};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${theme.colors.grey};
  }

  .ReactModal__Html--open,
  .ReactModal__Body--open {
    overflow: hidden;
  }
`
